import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-confirmation-modal-dialog',
  templateUrl: './confirmation-modal-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgTemplateOutlet,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    NgIf
  ],
  styleUrls: ['./confirmation-modal-dialog.component.scss']
})
export class ConfirmationModalDialogComponent {
  public title : string = 'Update/Delete Item'
  public description : string = 'Would you like to proceed with updating or deleting this item ?'
  public selectedItemName : string = ''
  public alertText : string = '' // optional

  public isConfirm: boolean = false

  constructor(
    public dialogRef: MatDialogRef<ConfirmationModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog) {
      this.title = data.title ?? this.title
      this.description = data.description ?? this.description
      this.selectedItemName = data.selectedItemName ?? this.selectedItemName
      this.alertText = data.alertText ?? this.alertText
    }
    
  confirmUpdate(){
    this.isConfirm = true
    this.closeDialog()
  }

  closeDialog(): void {
    this.dialogRef.close(this.isConfirm);
  }
}
